import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { MenuPage } from './menu.page';
import { CustomizeMenuService } from 'src/app/services/food/customize-menu.service';
import { MenuService } from 'src/app/services/food/menu.service';
import { CartService } from 'src/app/services/cart/cart.service';
import { LoaderService } from 'src/app/services/loader/loader.service';
import { ShoppingSharedModule } from '../../shared/shopping-shared.module';
import { BottomModalComponent } from 'src/app/modals/bottom-modal/bottom-modal.component';
import { CustomizationComponent } from './customization/customization.component';

const routes: Routes = [
  {
    path: '',
    component: MenuPage
  }
];

@NgModule({
  providers: [CustomizeMenuService, MenuService, CartService, LoaderService],
  imports: [
    IonicModule,
    ShoppingSharedModule,
    RouterModule.forChild(routes)
  ],
  entryComponents: [BottomModalComponent, CustomizationComponent],
  declarations: [MenuPage]
})
export class MenuPageModule { }
